import { createContext, useContext } from "react"

export const ZoomContext = createContext<number | undefined>(undefined)

export const useZoom = () => {
  const zoom = useContext(ZoomContext)
  if (zoom === undefined) {
    throw new Error("useZoom must be used within ZoomContext.Provider")
  }
  return zoom
}
